import React, { useEffect } from 'react';
import { format } from 'date-fns/esm';
import { parseISO } from 'date-fns';

import Modal from '../../../components/UI/Modals/Modal';
import { Diagnostic } from '../../../store/slices/checkIn';
import classes from './SelectProductModal.module.css';
import { useTranslation } from '../../../hooks/useTranslations';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  diagnostics: Diagnostic[];
  selectedDiagnostic?: Diagnostic;
  onChange: (e: any) => void;
  onSelectFirstProduct: () => void;
};
const SelectProductModal: React.FC<Props> = ({
  isOpen,
  onClose,
  diagnostics,
  selectedDiagnostic,
  onChange,
  onSelectFirstProduct,
}) => {
  useEffect(() => {
    if (diagnostics.length === 1) {
      onSelectFirstProduct();
    }
  }, [diagnostics]);
  const { translations } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={onClose} header={translations('select.the.diagnostics')}>
      <div className={classes.container}>
        <div>
          <select
            className={classes.biomarkerTableRowInputLarge}
            value={selectedDiagnostic?.diagnostic.sales_order.sales_order_id ?? 0}
            onChange={onChange}
          >
            <option disabled value={0}>
              {translations('please.select')}
            </option>
            {diagnostics?.map((diagnostic, index) => (
              <option key={index} value={diagnostic.diagnostic.sales_order.sales_order_id}>
                {`${
                  diagnostic.diagnostic.sales_order_appointment?.start
                    ? format(
                        parseISO(
                          diagnostic.diagnostic.sales_order_appointment?.start?.toString() ??
                            '01-01-1111'
                        ),
                        'dd.MM.yyyy, HH:mm'
                      )
                    : translations('label.walk_in')
                } ${diagnostic.diagnostic.product.product_name}`}
              </option>
            ))}
          </select>
        </div>
      </div>
    </Modal>
  );
};

export default React.memo(SelectProductModal);
